module.exports = __webpack_public_path__ + "static/media/16_c_2.fa1245cf.png";